<template>
  <div class="collection-card-skeleton">
    <!-- Блок изображения -->
    <div class="collection-card-skeleton__media skeleton-shimmer" />

    <div class="collection-card-skeleton__body">
      <!-- Название (1-2 линии) -->
      <div class="collection-card-skeleton__name">
        <div class="skeleton-line skeleton-shimmer" style="width: 100%;" />
        <div class="skeleton-line skeleton-shimmer" style="width: 60%;" />
      </div>

      <!-- Цена -->
      <div class="collection-card-skeleton__price">
        <div class="skeleton-line skeleton-shimmer" style="width: 100px; height: 28px;" />
      </div>

      <!-- Описание (2-3 линии) -->
      <div class="collection-card-skeleton__description">
        <div class="skeleton-line skeleton-shimmer" style="width: 100%;" />
        <div class="skeleton-line skeleton-shimmer" style="width: 90%;" />
        <div class="skeleton-line skeleton-shimmer" style="width: 75%;" />
      </div>

      <!-- Кнопка -->
      <div class="collection-card-skeleton__button skeleton-shimmer" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.collection-card-skeleton {
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 20px;
  border: 1px solid #EBEBEB;
  overflow: hidden;
  height: 100%;
}

.collection-card-skeleton__media {
  width: 100%;
  position: relative;
  border-radius: 20px 20px 5px 5px;
  background: #F4F3F1;

  &:after {
    content: "";
    float: left;
    padding-top: 70.153%;
  }
}

.collection-card-skeleton__body {
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  height: 224px;
}

.collection-card-skeleton__name {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-line {
  height: 16px;
  border-radius: 4px;
}

.collection-card-skeleton__price {
  margin-top: 4px;
}

.collection-card-skeleton__description {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.collection-card-skeleton__button {
  height: 48px;
  border-radius: 12px;
  margin-top: auto;
}

@media (max-width: 1023px) {
  .collection-card-skeleton__body {
    padding: 16px;
  }

  .collection-card-skeleton__button {
    margin-top: 24px;
  }
}

.skeleton-shimmer {
  background: linear-gradient(
    90deg,
    #f0f0f0 0%,
    #e0e0e0 20%,
    #f0f0f0 40%,
    #f0f0f0 100%
  );
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>

